import React from 'react';
import {
    useRecordContext,
    useRefresh,
    useNotify,
    useDataProvider,
    Button
} from 'react-admin';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { ShowActions } from '../../common/views/Show';

const TaskActionsButtons = () => {
    const record = useRecordContext();
    const refresh = useRefresh();
    const notify = useNotify();
    const dataProvider = useDataProvider();

    if (!record) return null;

    const handleAction = async (action) => {
        try {
            await dataProvider.create('tasks', {
                data: {},
                meta: { action }
            });
            notify('Task updated successfully', { type: 'info' });
            refresh();
        } catch (err) {
            notify('Error updating task', { type: 'error' });
        }
    };

    return (
        <ShowActions>
            {record.status !== 'in_progress' && record.status !== 'done' && record.status !== 'canceled' && (
                <Button
                    label="Start"
                    onClick={() => handleAction('mark_in_progress')}
                    startIcon={<PlayArrowIcon />}
                />
            )}

            {record.status === 'in_progress' && (
                <Button
                    label="Pause"
                    onClick={() => handleAction('mark_paused')}
                    startIcon={<PauseIcon />}
                />
            )}

            {record.status !== 'done' && record.status !== 'canceled' && (
                <Button
                    label="Complete"
                    onClick={() => handleAction('mark_completed')}
                    startIcon={<CheckCircleIcon />}
                />
            )}

            {record.status !== 'canceled' && record.status !== 'done' && (
                <Button
                    label="Cancel"
                    onClick={() => handleAction('mark_canceled')}
                    startIcon={<CancelIcon />}
                />
            )}
        </ShowActions>
    );
};

export default TaskActionsButtons;
